import {
	FilterableMailBoxUrlSlugs,
	MailBoxSlugs,
	MailBoxUrlSlugs,
	PrivateMailBoxUrlSlugs,
} from '@ukpostbox/client-data';
import { Location } from 'react-router';
import { MailScanned, MailType, UnreadType } from '../Types/MailFilterDataTypes';
import { BuildUrlFilterFromParams } from '../../_Global/Utils/UrlSlugsAndFilters';
import { BuildMailboxUrlFilterFromParamsType, MailboxUrlParamsType } from '../Types/MailboxUtilsTypes';

const MapFolderSlugToId = (props: MailboxUrlParamsType): number =>
	props.clientFolderIds || props.mailTagIds || props.unreadStatus
		? 8
		: parseInt(MailBoxSlugs[props.folderSlug as any], 10);

const BuildMailboxUrlFilterFromParams = (
	props: MailboxUrlParamsType,
	location: Location,
	name: keyof MailBoxUrlSlugs,
	data?: any,
	isArray?: boolean,
	overrideValue?: any,
): BuildMailboxUrlFilterFromParamsType => BuildUrlFilterFromParams(props, location, name, data, isArray, overrideValue);

const MailboxUrlMapping = (props: MailboxUrlParamsType, location: Location): PrivateMailBoxUrlSlugs => {
	let newParams: PrivateMailBoxUrlSlugs = {
		folderId: MapFolderSlugToId(props) as number,
	};

	if (props.clientFolderIds || location.state?.clientFolderIds !== undefined) {
		newParams = {
			...newParams,
			...BuildMailboxUrlFilterFromParams(props, location, 'clientFolderIds', null, true),
		};
	} else {
		newParams = {
			...newParams,
			...BuildMailboxUrlFilterFromParams(
				props,
				location,
				'includeFolderAssigned',
				null,
				false,
				newParams.folderId === 8,
			),
		};
	}

	return newParams;
};

const MailboxFilterUrlMapping = (props: MailboxUrlParamsType, location: Location): FilterableMailBoxUrlSlugs => {
	let newParams: FilterableMailBoxUrlSlugs = {};

	newParams = {
		...newParams,
		...BuildMailboxUrlFilterFromParams(props, location, 'term'),
		...BuildMailboxUrlFilterFromParams(props, location, 'startDate'),
		...BuildMailboxUrlFilterFromParams(props, location, 'endDate'),
		...BuildMailboxUrlFilterFromParams(props, location, 'mailType', MailType),
		...BuildMailboxUrlFilterFromParams(props, location, 'scanned', MailScanned),
		...BuildMailboxUrlFilterFromParams(props, location, 'unreadStatus', UnreadType),
		...BuildMailboxUrlFilterFromParams(props, location, 'mailTagIds', null, true),
		...BuildMailboxUrlFilterFromParams(props, location, 'incomingRecipientNameIds', null, true),
	};

	return newParams;
};

// TODO: update endpoints to return location name alongside id
const MapMailItemUrl = (locationId: number, mailUuid: string, customFolderId?: number) => {
	let slug = '';

	switch (locationId) {
		case 2: // 1
			slug = 'Inbox';
			break;
		case 0: // 2
			slug = 'Pending';
			break;
		case 1: //-
			slug = 'Forwarding Batches';
			slug = 'Inbox';
			break;
		case 3: // 4
			slug = 'Forwarded Items';
			break;
		case 7: // 5
			slug = 'Sent';
			break;
		case 6: // 6
			slug = 'Digital Store';
			break;
		case 4: // 7
			slug = 'Physical Store';
			break;
		// all = fid: 8
		case 20: // 9
			slug = 'Locked Items';
			break;
		default:
			slug = 'Unmapped';
	}

	return `/mail/${
		customFolderId ? `custom-folder/${customFolderId}` : slug.toLowerCase().replace(/ /g, '-')
	}/${mailUuid}`;
};

export {
	MapFolderSlugToId,
	MailboxUrlMapping,
	MailboxFilterUrlMapping,
	BuildMailboxUrlFilterFromParams,
	MapMailItemUrl,
};
